import ScopeConstants from "constants/ScopeConstants"
import ProposalStatusConstants from "constants/ProposalStatusConstants"

export const ProposalAnyScope = {
    key: ScopeConstants.PROPOSAL_ANY,
    selector: (state) => state.proposalsAny,
    tokenSelector: (state) => state.authentication.token,
    fetchEndpoint: "/api/Proposal/SearchAny/",
    singleEndpoint: "/api/Proposal/GetAny/",
    updateEndpoint: "/api/Proposal/UpdateAny/",
    deleteEndpoint: "/api/Proposal/DeleteAny/",
    publishEndpoint: "/api/Proposal/PublishAny/",
    defaultRecord: {
        name: "",
        code: "",
        status: ProposalStatusConstants.DRAFT
    }
}